import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty, samplingConstants } from '../Service/Utils';

import React from 'react';
import {
    Button,
    Row,
    Col,
    Select,
    Input,
    Table,
    Popover,
    Space,
    Divider,
    Image,
    Upload,
    Skeleton,
    Alert,
    message,
} from 'antd';
import {
    LeftOutlined,
    PlusOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    CloudUploadOutlined,
} from '@ant-design/icons';

class SamplingEventView extends React.Component {
    static uniqueKey = 1

    constructor() {
        super();
        this.state = {
            platform: '',
            status: '',
            pages: [],
            projectsGroups: {}
        };
    }

    render() {
        return <>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
                <Col style={{ margin: '0 20px 0 0' }}>
                    <span
                        style={{
                            color: 'gray',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.location = '/real_time/sampling'}
                    ><LeftOutlined /> 返回</span>
                </Col>
                <Col>
                    <span>注册/更新埋点信息</span>
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="916px">
                    <h4>事件归属</h4>
                </Col>
            </Row>
            <Divider
                style={{
                    margin: '0 0 20px 0'
                }}
            />
            {this.state.duplicatedDefId !== undefined &&
                <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                    <Col flex="916px">
                        <Alert 
                            message={<span>
                            "项目组+事件分组+事件标识/事件名称"与事件[<a href={`/real_time/sampling/edit/${this.state.duplicatedDefId}`}>{this.state.duplicatedDefId}</a>]重复
                            </span>}
                            type="error" 
                            showIcon 
                            closable
                            onClose={()=>this.setState({duplicatedDefId: undefined})}
                        />
                    </Col>
                </Row>}
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <sapn style={{ color: 'red' }}>*</sapn><span>项目组：</span>
                </Col>
                <Col flex="300px">
                    <Select
                        value={this.state.projectName}
                        onChange={projectName => this.refreshPages(projectName)}
                        size='small'
                        style={{ width: '100%' }}
                    >
                        {samplingConstants.projects.map(project => <Select.Option value={project.value}>
                            {project.title}
                        </Select.Option>)}
                    </Select>
                    {this.renderError('projectName')}
                </Col>
                <Col flex="16px" />
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <span>事件分组：</span>
                </Col>
                <Col flex="300px">
                    <Select
                        value={this.state.eventGroup}
                        allowClear
                        showSearch
                        disabled={isEmpty(this.state.projectName)}
                        placeholder="请输入/选择，回车确定"
                        style={{ width: '100%' }}
                        optionFilterProp="children"
                        size='small'
                        onChange={eventGroup => this.setState({ eventGroup, eventGroupError: undefined, incomingEventGroup: undefined })}
                        onSearch={eventGroup => this.setState({ incomingEventGroup: eventGroup })}
                        onInputKeyDown={e => {
                            if (e.code === 'Enter') {
                                this.addEventGroup();
                            }
                        }}
                        onBlur={e => this.addEventGroup()}
                        filterOption={(input, option) => {
                            return option?.txt?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
                        }}
                    >
                        {this.currentProjectGroups().map(group => <Select.Option key={group} value={group} txt={group}>
                            {group}
                        </Select.Option>)}
                    </Select>
                    {this.renderError('eventGroup')}
                    {/* <Select
                        value={this.state.eventGroup}
                        onChange={eventGroup => this.setState({ eventGroup })}
                        size='small'
                        style={{ width: '100%' }}
                    >
                        {this.currentProjectGroups().map(g => <Select.Option value={g}>{g}</Select.Option>)}
                    </Select> */}
                </Col>
            </Row>
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <span>所属页面(可多选)：</span>
                </Col>
                <Col flex="666px">
                    <Select
                        value={this.state.associatedKeys}
                        onChange={associatedKeys => this.setState({ associatedKeys })}
                        allowClear
                        disabled={isEmpty(this.state.projectName)}
                        mode="multiple"
                        size='small'
                        style={{ width: '100%' }}
                    >
                        {this.state.pages.map(page => <Select.Option
                            value={page.id}
                        >
                            {page.name}
                        </Select.Option>)}
                    </Select>
                </Col>
                <Col flex="100px">
                    <a
                        href='/real_time/sampling/pages'
                        style={{ fontSize: 12 }}
                    >先去创建页面</a>
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="916px">
                    <h4>基本信息</h4>
                </Col>
            </Row>
            <Divider
                style={{
                    margin: '0 0 20px 0'
                }}
            />
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <sapn style={{ color: 'red' }}>*</sapn><span>事件标识(英文名)：</span>
                </Col>
                <Col flex="300px">
                    <Input
                        value={this.state.eventName}
                        onChange={({ target: { value } }) => this.setEventName(value)}
                        size="small"
                        placeholder="建议格式为xxx_xxx_xxx"
                    />
                    {this.renderError('eventName')}
                </Col>
                <Col flex="16px" />
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <sapn style={{ color: 'red' }}>*</sapn><span>事件名称(中文名)：</span>
                </Col>
                <Col flex="300px">
                    <Input
                        value={this.state.eventNameChs}
                        onChange={({ target: { value } }) => this.setState({ eventNameChs: value, eventNameChsError: undefined })}
                        size="small"
                        style={{ width: '100%' }}
                    />
                    {this.renderError('eventNameChs')}
                </Col>
            </Row>
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <sapn style={{ color: 'red' }}>*</sapn><span>事件类型：</span>
                </Col>
                <Col flex="300px">
                    <Select
                        value={this.state.eventType}
                        onChange={eventType => {
                            this.setState({ eventType, eventTypeError: undefined });
                            if (eventType !== 'custom_event') {
                                this.setState({
                                    eventTypeChs: samplingConstants.eventTypes.find(t => t.value === eventType).title,
                                    eventTypeChsError: undefined
                                });
                            } else {
                                this.setState({
                                    eventTypeChs: undefined,
                                    eventTypeChsError: undefined
                                });
                            }
                        }}
                        size="small"
                        style={{ width: '100%' }}
                    >
                        {samplingConstants.eventTypes.map(type =>
                            <Select.Option value={type.value}>{type.value}({type.title})</Select.Option>)}
                    </Select>
                    {this.renderError('eventType')}
                </Col>
                {this.state.eventType !== 'custom_event' && <Col flex='466px' />}
                {this.state.eventType === 'custom_event' && <>
                    <Col flex="16px" />
                    <Col flex="450px">
                        <Input
                            value={this.state.eventTypeChs}
                            onChange={({ target: { value } }) => this.setState({ eventTypeChs: value, eventTypeChsError: undefined })}
                            size="small"
                            style={{ width: '100%' }}
                            placeholder="输入事件类型，不超过20个字符"
                            maxLength={20}
                        />
                        {this.renderError('eventTypeChs')}
                    </Col>
                </>}
            </Row>
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <sapn style={{ color: 'red' }}>*</sapn>
                    <span>上报时机 <Popover
                        title="提示信息"
                        content={<span>定义埋点上报的场景和时机，如：想看有多少人领了优惠券，应该在优惠券领取成功时上报（而不是点击领取就上报）</span>}
                    >
                        <InfoCircleOutlined />
                    </Popover>：</span>
                </Col>
                <Col flex="766px">
                    <Input
                        value={this.state.eventTrigger}
                        onChange={({ target: { value } }) => this.setState({ eventTrigger: value, eventTriggerError: undefined })}
                        size="small"
                        style={{ width: '100%' }}
                        placeholder="输入埋点上报场景和时机"
                    />
                    {this.renderError('eventTrigger')}
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="150px" style={{ alignSelf: 'start', textAlign: 'right' }}>
                    <span >上传图片：</span>

                </Col>
                <Col flex="300px">
                    <Row>
                        {isNotEmpty(this.state.pictureStorageKey) ? <Image
                            src={`/api/v1/sampling/pictures/preview?key=${encodeURI(this.state.pictureStorageKey)}`}
                            height={100}
                        /> : <Skeleton.Image style={{ height: 100, width: 100 }} />}
                    </Row>
                    <Row justify='center'>
                        <Col>
                            {this.renderUploader()}
                            {isNotEmpty(this.state.pictureStorageKey) &&
                                <Button
                                    size='small'
                                    type="link"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => this.setState({ pictureStorageKey: undefined })}
                                />}
                        </Col>
                    </Row>
                </Col>
                <Col flex="16px"></Col>
                <Col flex="150px" style={{ textAlign: 'right' }}>
                    <span >备注：</span>
                </Col>
                <Col flex="300px">
                    <Input.TextArea
                        value={this.state.comments}
                        onChange={({ target: { value } }) => this.setState({ comments: value, commentsError: undefined })}
                        rows={4}
                        style={{ width: '100%' }}
                    />
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="916px">
                    <h4>业务属性</h4>
                </Col>
            </Row>
            <Divider
                style={{
                    margin: '0 0 20px 0'
                }}
            />
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col flex="916px">
                    {this.expandedRowRender({ json: this.state.eventValue })}
                </Col>
            </Row>
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }} justify='center'>
                <Col>
                    {this.isAdding()
                        ? <Space>
                            <Button onClick={this.add.bind(this)} type="primary">注册</Button>
                            <Button onClick={() => window.location = '/real_time/sampling'}>取消</Button>
                        </Space>
                        : <Space>
                            <Button onClick={this.update.bind(this)} type="primary">更新</Button>
                            <Button onClick={() => window.location = '/real_time/sampling'}>取消</Button>
                        </Space>}
                </Col>
            </Row>
        </>
    }

    currentProjectGroups() {
        if (isEmpty(this.state.projectName) || isEmpty(this.state.projectsGroups)) {
            return [];
        }
        return this.state.projectsGroups[this.state.projectName] === undefined ? [] : this.state.projectsGroups[this.state.projectName];
    }

    addEventGroup() {
        const eg = this.state.incomingEventGroup;
        if (isEmpty(eg) || isEmpty(this.state.projectName)) {
            return;
        }
        this.setState(({ eventGroup, projectsGroups, projectName }) => {
            eventGroup = eg;
            const groups = projectsGroups[projectName];
            if (groups === undefined) {
                projectsGroups[projectName] = [eg];
            } else {
                if (groups.find(g => g === eg) === undefined) {
                    groups.push(eg);
                }
            }
            return { eventGroup, projectsGroups, eventGroupError: undefined };
        });
    }

    isEditing() { return this.props.defId !== undefined; }
    isAdding() { return !this.isEditing(); }

    expandedRowRender(record, index, indent, expanded) {
        const error = (rd, key) => isNotEmpty(rd[key + 'Error']) ? <span style={{ color: 'red', fontSize: 12 }}>
            {rd[key + 'Error']}
        </span> : <></>
        return <Table
            dataSource={indent === undefined ? this.state.eventValue : record.json}
            bordered
            size="small"
            style={{ width: '100%' }}
            scroll={{ x: 600 }}
            expandable={{
                expandedRowRender: this.expandedRowRender.bind(this),
                rowExpandable: rd => isNotEmpty(rd.json)
            }}
            pagination={false}
            footer={() => <Row justify="center">
                <Col flex="100%">
                    <Button
                        icon={<PlusOutlined />}
                        type="link"
                        size="small"
                        style={{ width: '100%' }}
                        onClick={() => {

                            this.setState(({ eventValue }) => {
                                //console.log(eventValue);
                                const key = (SamplingEventView.uniqueKey++).toString();
                                const item = { key };
                                if (indent === undefined) {
                                    if (isEmpty(eventValue)) {
                                        return { eventValue: [item] };
                                    }
                                    eventValue.push(item);
                                } else {
                                    if (isEmpty(record.json)) {
                                        record.json = [item];
                                    } else {
                                        record.json = [...record.json, item];
                                    }
                                }
                                return { eventValue: [...eventValue] };
                            });
                        }}
                    ></Button>
                </Col>
            </Row>}
        >
            <Table.Column
                title="属性标识(英文名)"
                dataIndex="name"
                key="name"
                width={150}
                render={(name, rd) => <><Input
                    value={name}
                    onChange={({ target: { value } }) => this.setState(({ eventValue }) => {
                        rd.name = value
                        delete rd.nameError;
                        return { eventValue };
                    })}
                    size="small"
                    style={{ width: '100%' }}
                />
                    {error(rd, 'name')}
                </>}
            />
            <Table.Column
                title="属性名称(中文名)"
                dataIndex="nameChs"
                key="nameChs"
                width={200}
                render={(nameChs, rd) => <>
                    <Input
                        value={nameChs}
                        onChange={({ target: { value } }) => this.setState(({ eventValue }) => {
                            rd.nameChs = value
                            delete rd.nameChsError;
                            return { eventValue };
                        })}
                        size="small"
                        style={{ width: '100%' }}
                    />
                    {error(rd, 'nameChs')}
                </>}
            />
            <Table.Column
                title="字段类型"
                dataIndex="type"
                key="type"
                width={180}
                render={(type, rd) => <>
                    <Select
                        value={type}
                        onChange={type => this.setState(({ eventValue }) => {
                            if (type === 'json') {
                                rd.json = [];
                            } else {
                                delete rd.json;
                            }
                            rd.type = type;
                            delete rd.typeError;
                            return { eventValue: [...eventValue] };
                        })}
                        size="small"
                        style={{ width: '100%' }}
                    >
                        <Select.Option value="number">数值</Select.Option>
                        <Select.Option value="string">字符串</Select.Option>
                        <Select.Option value="date">日期(yyyy-MM-dd)</Select.Option>
                        <Select.Option value="timestamp">时间戳(秒)</Select.Option>
                        <Select.Option value="timestamp_ms">时间戳(毫秒)</Select.Option>
                        <Select.Option value="json">Json</Select.Option>
                        <Select.Option value="enum">枚举</Select.Option>
                    </Select>
                    {error(rd, 'type')}
                    {type === 'enum' && <Input
                        value={rd.enumValues}
                        onChange={({ target: { value } }) => this.setState(({ eventValue }) => {
                            rd.enumValues = value;
                            return { eventValue };
                        })}
                        size="small"
                        placeholder="请输入枚举值,逗号(,)分隔"
                        style={{ width: '100%', margin: '10px 0 0 0' }}
                    />}
                </>}
            />
            <Table.Column
                title="操作"
                dataIndex="key"
                key="operator"
                width={80}
                fixed="right"
                render={(_1, _2, row) => <Space>
                    <Button
                        icon={<DeleteOutlined />}
                        danger
                        type="link"
                        onClick={() => this.setState(({ eventValue }) => {
                            if (indent === undefined) {
                                eventValue = eventValue.filter((_, i) => i !== row);
                            } else {
                                record.json = record.json.filter((_, i) => i !== row);
                                console.log(record);
                            }
                            return { eventValue };
                        })}
                    ></Button>
                </Space>}
            />
        </Table>;
    }

    renderError(key) {
        if (isEmpty(this.state[key + 'Error'])) {
            return <></>;
        } else {
            return <span style={{ color: 'red', fontSize: 12 }}>{this.state[key + 'Error']}</span>;
        }
    }

    async componentDidMount() {
        console.log(window.location);

        if (this.props.defId === undefined) {
            // add
            const params = {}
            window.location.search.substring(1).split('&').forEach(part => {
                const segs = part.split('=');
                params[segs[0]] = segs[1];
            });

            if (isNotEmpty(params.projectName)) {
                this.setState({ projectName: params.projectName });
                await this.refreshPages(params.projectName);
            }
            if (isNotEmpty(params.associatedKeys)) {
                this.setState({ associatedKeys: params.associatedKeys.split(',').map(key => Number.parseInt(key)) });
            }
        } else {
            // update
            const def = await UIFetchService.get(`/api/v1/sampling/definitions/${this.props.defId}`);
            await this.refreshPages(def.projectName);
            this.setState(def);
        }
    }

    async refreshPages(projectName) {
        this.setState({ projectName, associatedKeys: [], eventGroup: undefined, projectNameError: undefined });
        //const filters = encodeURI(JSON.stringify({ projectName: [projectName] }));
        const rv = await UIFetchService.get(`/api/v1/sampling/pages?projectName=${projectName}&pageNo=1&pageSize=10000`);
        if (rv) {
            this.setState({ pages: rv.items });
        }
        const projectsGroups = await UIFetchService.get('/api/v1/sampling/projects/groups');
        this.setState({ projectsGroups });
    }

    setEventName(value) {
        this.setState({ eventName: value, eventNameError: undefined });
        let url = '/api/v1/sampling/definitions/by_name';
        url = `${url}?projectName=${this.isAdding() ? this.state.projectName : this.state.projectName}`;
        url = `${url}&name=${value}`;
        url = `${url}&excludeId=${this.isAdding() ? '' : this.props.defId}`;
        UIFetchService.get(url)
            .then(rs => {
                if (rs.id !== undefined) {
                    this.setState({ eventNameError: '事件标识不能重复' });
                }
            });
    }

    setPlatform(values) {
        this.setState({ platform: (values.join(',')) });
        let page = this.state.page;
        if (page instanceof Object) {
            // pass
        } else {
            page = {};
        }
        for (let key of values) {
            if (page[key] === undefined) {
                page[key] = '';
            }
        }
        for (let key of Object.keys(page)) {
            if (values.find(v => v === key) === undefined) {
                delete page[key];
            }
        }

        this.setState({ page });
    }

    async add() {
        if ((await this.check()) > 0) {
            message.error('填写错误，无法提交。')
            return;
        }

        const params = { ...this.state, appName: 'IGNORE' };
        const rv = await UIFetchService.post('/api/v1/sampling/definitions', params);
        if (rv) {
            if (isNotEmpty(this.state.associatedKeys) && this.state.associatedKeys.length > 0) {
                await UIFetchService.put(`/api/v1/sampling/definitions/${rv.defId}/associated_pages`, this.state.associatedKeys);
            }
            window.location = '/real_time/sampling'
        }
    }

    async update() {
        if ((await this.check()) > 0) {
            message.error('填写错误，无法提交。')
            return;
        }
        const params = { ...this.state };
        await UIFetchService.method('PUT', `/api/v1/sampling/definitions/${this.props.defId}`, params);
        window.location = '/real_time/sampling'
    }

    removeErrorTag(json) {
        for (let rd of json) {
            Object.keys(rd).forEach(key => {
                if (key.endsWith('Error')) {
                    delete rd[key];
                }
            });
            if (rd.json !== undefined && rd.json !== null) {
                this.removeErrorTag(rd.json);
            }
        }
    }

    async check() {
        let err = 0;
        const ctx = {};
        const keys = {
            projectName: '项目组',
            eventName: '事件标识',
            eventNameChs: '事件名称',
            eventType: '事件类型',
            eventTrigger: '上报时机'
        };

        if (this.state.eventType === 'custom_event' && samplingConstants.eventTypes.some(t => t.value === this.state.eventTypeChs)) {
            ctx.eventTypeChsError = "自定义事件类型不能与现有事件类型枚举值重复"
            err++
        }

        for (let key of Object.keys(keys)) {
            if (isEmpty(this.state[key])) {
                ctx[key + 'Error'] = `${keys[key]}不能为空`;
                err++;
            } else {
                ctx[key + 'Error'] = undefined;
            }
        }

        if (isEmpty(ctx.eventNameError)) {
            let url = '/api/v1/sampling/definitions/by_identifier';
            url = `${url}?projectName=${this.isAdding() ? this.state.projectName : this.state.projectName}`;
            url = `${url}&name=${this.state.eventName}`;
            if (isNotEmpty(this.state.eventGroup)) {
                url = `${url}&eventGroup=${this.state.eventGroup}`;
            }
            url = `${url}&excludeId=${this.isAdding() ? '' : this.props.defId}`;
            const rs = await UIFetchService.get(url);
            if (rs.id !== undefined) {
                ctx.eventNameError = `"项目组+事件分组+事件标识/事件名称"不能重复`;
                ctx.eventGroupError = `"项目组+事件分组+事件标识/事件名称"不能重复`;
                ctx.projectNameError = `"项目组+事件分组+事件标识/事件名称"不能重复`;
                ctx.duplicatedDefId = rs.id;
                err++;
            } else {
                delete ctx.eventNameError;
                delete ctx.eventGroupError;
                delete ctx.projectNameError;
            }
        }

        if (isNotEmpty(this.state.eventValue)) {
            err += this.checkEventValue(this.state.eventValue, {}, {});
            ctx.eventValue = this.state.eventValue;
        }
        this.setState(ctx);
        return err;
    }

    checkEventValue(json, uniqueName, uniqueChs) {
        let err = 0;
        for (let rd of json) {
            if (isEmpty(rd.name)) {
                err++;
                rd.nameError = '属性标识不能为空';
            } else {
                if (uniqueName[rd.name] === undefined) {
                    delete rd.nameError;
                    uniqueName[rd.name] = true;
                } else {
                    err++;
                    rd.nameError = '属性标识不能重复';
                }
            }

            if (isEmpty(rd.nameChs)) {
                err++;
                rd.nameChsError = '属性名称不能为空';
            } else {
                if (uniqueChs[rd.nameChs] === undefined) {
                    delete rd.nameChsError;
                    uniqueChs[rd.nameChs] = true;
                } else {
                    err++;
                    rd.nameChsError = '属性名称不能重复';
                }
            }

            if (isEmpty(rd.type)) {
                err++;
                rd.typeError = '类型不能为空';
            } else {
                delete rd.typeError;
            }
            if (rd.json !== undefined && rd.json !== null) {
                console.log(rd);
                err += this.checkEventValue(rd.json, uniqueName, uniqueChs);
            }
        }
        return err;
    }

    renderUploader() {
        return <Upload
            name="file"
            action={`/api/v1/sampling/pictures/temp_media_file`}
            accept="image/png,image/jpg,image/jpeg"
            maxCount={1}
            showUploadList={false}
            onChange={info => this.uploadingDidChanged(info)}
            beforeUpload={file => {
                return true;
            }}
        >
            <Button
                danger
                icon={<CloudUploadOutlined />}
                type="link"
                size="small"
                style={{ color: '#1890ff' }}
            ></Button>
        </Upload>;
    }

    uploadingDidChanged(info) {
        switch (info.file.status) {
            case 'uploading':
                break;
            case 'done':
                this.setState({ pictureStorageKey: info.file.response.key });
                break;
            case 'error':
                message.error('文件上传失败');
                break;
            default:
                break;
        }
    }
}

export default SamplingEventView;